import RoomManagement from '../src/components/sections/RoomManagement';

export default RoomManagement;
